import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const activityApi = createApi({
  reducerPath: "activityApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: [],
  endpoints: (builder) => ({
    getAllActivityLogs: builder.query({
      query: ({ page = 1, limit = 10, search = "", activityType = "", startDate = "", endDate = "" }) => ({
        url: "/activitylogs",
        method: "GET",
        params: {
          page,
          limit,
          search,
          ...(activityType && { activityType }),
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
        },
      }),
    }),
    cleanupActivityLogs: builder.mutation({
      query: () => ({
        url: "/activitylogs/cleanup",
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllActivityLogsQuery,
  useLazyGetAllActivityLogsQuery,
  useCleanupActivityLogsMutation,
} = activityApi;
